import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
	strict: process.env.NODE_ENV === "development",
	state: {
		fontScale: +(localStorage.getItem("controle/fonte")) || 1,
		sideBarWidth: 0,
		usuarioLogado: null,
		account: null,
		category: null,
		customer: null,
		accountClass: null,
		product: null,
		productClass: null,
		taxe: null,
		showCharts: []
	},
	mutations: {
		updateSideBarWidth (state, w) {
			state.sideBarWidth = w;
		},

		setFontScale (state, scale) {
			if (!+scale) return;
			if (scale > 3) scale = 3;
			if (scale < 1) scale = 1;
			localStorage.setItem("controle/fonte", scale);
			state.fontScale = scale;
		},

		initUsuarioLogado (state, value) {
			state.usuarioLogado = value || null;
		},

		setUsuarioLogado (state, value) {
			if (value) {
				const userData = {
					usuario: value.user,
					token: value.token,
					grupoUsuario: value.permissoes.toString(),
					nomeUsuario: value.nomeUsuario,
					nomeUsuarioCompleto: value.nomeUsuarioCompleto,
					idUsuario: value.idUser,
					email: value.email,
					config: value.config,
					subscriptionActive: value.subscriptionActive,
					enterprise: value.enterprise,
					identityEnterprise: value.identityEnterprise,
					addressEnterprise: value.addressEnterprise,
					telephoneEnterprise: value.telephoneEnterprise,
					emailConfig: value.emailConfig,
					logo: value.logo,
					watermark: value.watermark,
					subscription: {
						amount: value.subscriptionValue,
						nextPayDate: value.nextPayDate
					},
					chatBotId: value.chatBotId,
					refreshToken: value.refreshToken
				};
				localStorage.setItem("params", JSON.stringify(userData));
				state.usuarioLogado = userData;
			} else {
				localStorage.removeItem("params");
				state.usuarioLogado = null;
			}
		},

		initAccount (state, value) {
			state.account = value || null;
		},

		setAccount (state, value) {
			if (value) {
				state.account = value;
			} else {
				state.account = null;
			}
		},

		initAccountClass (state, value) {
			state.accountClass = value || null;
		},

		setAccountClass (state, value) {
			if (value) {
				state.accountClass = value;
			} else {
				state.accountClass = null;
			}
		},

		initCategory (state, value) {
			state.category = value || null;
		},

		setCategory (state, value) {
			if (value) {
				state.category = value;
			} else {
				state.category = null;
			}
		},

		initCustomer (state, value) {
			state.customer = value || null;
		},

		setCustomer (state, value) {
			if (value) {
				state.customer = value;
			} else {
				state.customer = null;
			}
		},

		initProduct (state, value) {
			state.product = value || null;
		},

		setProduct (state, value) {
			if (value) {
				state.product = value;
			} else {
				state.product = null;
			}
		},

		initProductClass (state, value) {
			state.productClass = value || null;
		},

		setProductClass (state, value) {
			if (value) {
				state.productClass = value;
			} else {
				state.productClass = null;
			}
		},

		initTaxe (state, value) {
			state.taxe = value || null;
		},

		setTaxe (state, value) {
			if (value) {
				state.taxe = value;
			} else {
				state.taxe = null;
			}
		},

		initShowCharts (state, value) {
			state.showCharts = value || [];
		},

		setShowCharts (state, value) {
			if (value) {
				state.showCharts = value;
			} else {
				state.showCharts = [];
			}
		}
	}
});

export default store;
